import React from 'react'
import { getValidUrlToLink } from '@mprolab/sdk'
import styled, { useTheme } from 'styled-components'
import { SocialMediaIconProps } from './types'
import { Flex } from '../Flex'

const StyledIcon = styled(({ icon: Icon, ...props }) => <Icon {...props} />)`
  color: ${(props) => props.theme.colors.gray6};

  cursor: ${(props) => (props.disabled ? 'not-allowed' : 'pointer')};
  opacity: ${(props) => (props.disabled ? 0.6 : 1)};

  &:not([disabled]):hover {
    color: ${(props) => props.href && !props.disabled && props.theme.colors.purple};
  }

  &:not([disabled]):hover path {
    transition: all ease-in-out 0.3s;
    fill: ${(props) => props.href && !props.disabled && props.customIcon && props.theme.colors.purple};
  }
`

const SocialMediaIcon: React.FC<SocialMediaIconProps> = ({ href, customIcon, ...props }) => {
  const { colors } = useTheme()

  return (
    <Flex onClick={() => !props.disabled && window.open(getValidUrlToLink(href), '_blank')}>
      <StyledIcon color={customIcon && colors.gray6} {...{ href, customIcon }} {...props} />
    </Flex>
  )
}

export default SocialMediaIcon
